import { render, staticRenderFns } from "./TicketGreedNew.vue?vue&type=template&id=60c312e2&scoped=true&"
import script from "./TicketGreedNew.vue?vue&type=script&lang=js&"
export * from "./TicketGreedNew.vue?vue&type=script&lang=js&"
import style0 from "./TicketGreedNew.vue?vue&type=style&index=0&id=60c312e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c312e2",
  null
  
)

export default component.exports